import { render, staticRenderFns } from "./PhotoVerifyView.vue?vue&type=template&id=603ba36a&scoped=true&"
import script from "./PhotoVerifyView.vue?vue&type=script&lang=ts&"
export * from "./PhotoVerifyView.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoVerifyView.vue?vue&type=style&index=0&id=603ba36a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603ba36a",
  null
  
)

export default component.exports